import React, { ReactElement, useState } from "react";
import Button from "@components/shared/form/button";
import { useQuery } from "@tanstack/react-query";
import { translate } from "@helpers/translationObjectFormatter";
import { FormActionTypes, TranslationsObject } from "@genericTypes/sharedTypes";
import { GQLCategories, GQLForms } from "@gql/types/gql";
import XVector from "./XVector";
import styles from "./style.module.scss";
import Image from "next/image";
import { useDispatch } from "../form/formReducer/FormReducer";
export default function FreeQuotePopup({
    category,
}: {
    category: GQLCategories;
}): ReactElement {
    const formData = useQuery<GQLForms>({
        queryKey: ["activeForm", category.slug],
    }).data?.domainForm;
    const { data: translations } = useQuery<TranslationsObject>([
        "translations",
    ]);

    const dispatch = useDispatch();

    const [animate, setAnimate] = useState(false);
    const [opened, setOpened] = useState(true);
    setTimeout(() => {
        setAnimate(true);
    }, 3000);

    return (
        <>
            {formData && opened && (
                <div
                    className={`${styles["mainContainer"]}  ${
                        animate ? styles["animation"] : ""
                    } `}
                >
                    <div className=" max-w-[204px] py-6">
                        <h3 className="font-bold text-lg">
                            {`${translate(
                                translations,
                                "several_general_freeQuotePopupTitle",
                            )} ${(category.label ?? category.name) as string}`}
                        </h3>
                        <p className="font-medium text-xs mt-1">
                            {`${translate(
                                translations,
                                "several_general_freeQuotePopupDescription",
                            )} ${(category.label ?? category.name) as string}`}
                        </p>
                        <Button
                            onClick={() => {
                                dispatch({
                                    type: FormActionTypes.SET_STEP_TO_SHOW_BACK_BTN,
                                    payload: 1,
                                });
                                dispatch({
                                    type: FormActionTypes.SET_MODAL_VISIBILITY,
                                    payload: true,
                                });
                                setTimeout(() => {
                                    setOpened(false);
                                }, 300);
                            }}
                            className="py-2 font-bold text-sm mt-2"
                        >
                            {translate(
                                translations,
                                "several_general_freeQuotePopupButton",
                            )}
                        </Button>
                    </div>
                    <Image
                        src={"/freeQuotePopup_v2.png"}
                        alt="image"
                        width={113}
                        height={177}
                    />

                    <div
                        className={`mt-3  h-fit p-1 ${styles["btnHoverStyle"]} cursor-pointer`}
                        onClick={() => {
                            setOpened(false);
                        }}
                    >
                        <XVector />
                    </div>
                </div>
            )}
        </>
    );
}
